module.exports = __webpack_public_path__ + "img/hreart.07fc4b44.png";